import React from "react";

import Section1 from "./components/Section1";
import Section9 from "./components/Section9";
import Section10 from "./components/Section10";
import Case1 from "./components/Case1";
import Case2 from "./components/Case2";
import Case3 from "./components/Case3";
import Case4 from "./components/Case4";

function JasaIklan() {
  return (
    <div className="min-h-screen bg-white">
      <Section1 />
      <Section9 />
      <Case1 />
      <Case2 />
      <Case3 />
      <Case4 />
      <Section10 />
    </div>
  );
}

export default JasaIklan;
